import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertController, ToastController } from '@ionic/angular';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  user = new BehaviorSubject({ permission: '', isSubscribed: false, subscriptions: [], isExpired: false });
  private isInitialized = false;
  private authToken: string; // Add authToken property if needed

  constructor(
    private platform: Platform,
    private toastController: ToastController, 
    private alertController: AlertController
  ) {}

  async init(user: any) {
    console.log('SubscriptionService: Initializing (no-op stub)');
    this.isInitialized = true;
    this.checkUserExpiry();
  }

  private async initRevenueCat(appUserID: string) {}

  private ensureInitialized(): boolean {
    if (!this.isInitialized) {
      console.debug('SubscriptionService is not initialized.');
      return false;
    }
    return true;
  }

  // Get offerings
  async getOfferings(): Promise<{ [key: string]: any }> {
    if (!this.ensureInitialized()) return {};
  
    try {
      // No-op: subscriptions disabled
      return {};

    } catch (error) {
      console.error('Failed to get offerings:', error);
      return {};
    }
  }

  // Method to handle the purchase
  async purchase(pkg: any): Promise<boolean> {
    if (!this.ensureInitialized()) return false;

    console.log('Purchasing is disabled (no-op)');
    await this.showAlert('Purchases disabled', 'Purchases are temporarily unavailable.');
    return false;
  }

  handleExistingPermissions(entitlements: { [key: string]: any }) {
    console.log('Existing entitlements: ', entitlements);

    const user = this.user.getValue();
    user.subscriptions = [];
    
    if (entitlements['starter']?.isActive) {
      user.isSubscribed = true;
      user.permission = 'Starter';
      user.subscriptions.push(entitlements['starter']);
    } else if (entitlements['pro']?.isActive) {
      user.isSubscribed = true;
      user.permission = 'Professional';
      user.subscriptions.push(entitlements['pro']);
    } else if (entitlements['advanced']?.isActive) {
      user.isSubscribed = true;
      user.permission = 'Advanced';
      user.subscriptions.push(entitlements['advanced']);
    } else {
      user.isSubscribed = false;
      user.permission = 'Trial';
    }

    this.user.next(user);
  }

  async handleSuccessfulTransactionResult(result: { customerInfo: any }) { // no-op
    try {
      console.log('Successful transaction result (stub):', result.customerInfo);
  
    } catch (error) {
      console.error('Error handling successful transaction result:', error);
      // Handle errors that might occur during processing
    }
  }

  async updateBackendWithSubscriptionStatus(customerInfo: any) {
    try {
      const response = await fetch('https://yourapi.com/subscription/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.authToken}`
        },
        body: JSON.stringify({
          //userId: customerInfo.customerId, // Adjusted to correct property
          entitlements: customerInfo?.entitlements?.active,
          purchaseDate: customerInfo?.latestExpirationDate,
        })
      });

      if (!response.ok) {
        throw new Error('Failed to update backend with subscription status');
      }
    } catch (error) {
      console.error('Error updating backend with subscription status:', error);
    }
  }

  notifySubscriptionUpdate(customerInfo: any) {
    // Emit an event or notify other services
    console.log('Notify other parts of the app about subscription update', customerInfo);
    // Example: this.eventEmitter.emit('subscriptionUpdated', customerInfo);
  }

  async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header: header,
      message: message,
      buttons: ['OK']
    });

    await alert.present();
  }

  checkUserExpiry() {
    // Example logic for checking user expiry
  }

  async restore(): Promise<boolean> {
    if (!this.ensureInitialized()) return false;

    // Restore purchases
    try {
      console.log('Restore is disabled (no-op)');
      return false;
    } catch (error) {
      console.error('Failed to restore purchases:', error);
      return false;
    }
  }
}
